import { createSelector } from 'reselect';
import { connect } from 'react-redux';
import sharingSelector from '@store/common/sharing/selectors';
import commonSelector from '@store/common/selectors';
import get from 'lodash/get';
import * as sharingActions from '@store/common/sharing/actions';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import Sharing from './Sharing';

const selector = createSelector(
  sharingSelector,
  commonSelector,
  activeDashboardSelector,
  (store, common, activeDashboard) => ({
    usecaseKey: activeDashboard?.usecaseKey,
    isFetching: store.isFetching,
    id: store.response || 0,
    title: get(store, ['payload', 'title'], ''),
    cid: common.profiles.filter((p) => p.is_selected)[0].customer_id,
  }),
);

export default connect(selector, { startShare: sharingActions.startShare })(Sharing);
